export const en = {
  nav: {
    about: 'About Us',
    services: 'Services',
    blog: 'Blog',
    booking: 'Booking',
  },
  hero: {
    title: 'Sunshine Healing · Soul Awakening',
    subtitle: 'Professional healing to guide your inner journey',
    description1: 'Here, you will experience profound soul healing and energy balance. We are dedicated to helping every visitor rediscover inner peace, reconnect with their authentic self, and embark on a journey of spiritual growth.',
    bookNow: 'Book Now',
    learnMore: 'Learn More',
    bilingual: 'Bilingual Service',
  },
  services: {
    title: 'Healing Services',
    subtitle: 'Professional spiritual healing for deep nourishment and transformation of body, mind and spirit',
    pellowah: {
      title: 'PELLOWAH',
      subtitle: 'PELLOWAH Energy Healing',
      description: 'Pellowah is a high-frequency spiritual healing modality that directly connects to the Higher Self, expands consciousness, and helps you break through inner limitations to open new life perspectives and spiritual awareness.',
      button: 'Learn More',
    },
    umana: {
      title: 'UMANA',
      subtitle: 'UMANA Energy Healing',
      description: 'UMANA is a technology that activates Chakras 8–12 above the physical body, designed to promote growth, transformation and empowerment — a battery recharge for the Soul.',
      button: 'Learn More',
      tag: 'Popular · Activates Chakras 8–12',
    },
    bach: {
      title: 'Bach Flower Remedies',
      subtitle: 'Natural Flower Essence Healing',
      description: 'Using the vibrational energy of 38 natural flower essences, gently and precisely harmonizing negative emotions and mental states, healing emotional imbalance at the root and rebuilding inner calm and confidence.',
      button: 'Learn More',
      tag: 'Recommended for Emotional Healing',
    },
    quantum: {
      title: 'Quantum Hypnosis',
      subtitle: 'Deep Consciousness Exploration',
      description: 'Through deep hypnotic guidance, connect with the subconscious and Higher Self wisdom to explore past lives, soul missions and life lessons, gaining profound inner insights and healing transformation.',
      button: 'Learn More',
      tag: 'Deep Dive',
    },
    oracle: {
      title: 'Oracle Card Reading',
      subtitle: 'Divine Wisdom & Intuitive Guidance',
      description: 'Using the divine wisdom and intuitive guidance of oracle cards to bring clarity and insight to your current life questions, connecting with inner wisdom to find direction and strength for moving forward.',
      button: 'Learn More',
      tag: 'Intuitive',
    },
    chakra: {
      title: 'Chakra Assessment',
      subtitle: 'Energy Centre Evaluation & Balancing',
      description: 'Through systematic evaluation of the seven major chakra energy centres, precisely locate energy blockages and imbalances, understand the deep connection between body, emotions and spirit, and create a personalised healing plan.',
      button: 'Learn More',
      tag: 'Self-Discovery',
    },
  },
  testimonials: {
    title: 'Testimonials',
    quote: 'This healing experience helped me rediscover inner peace. The guidance was professional and warm. I felt truly understood and supported throughout the entire process. Thank you so much.',
    name: 'Ms. Zhang',
    role: 'Corporate Executive',
    button: 'More Reviews',
  },
  cta: {
    title: 'Begin Your Healing Journey',
    subtitle: 'Return to Inner Peace',
    button: 'Book a Consultation',
  },
  booking: {
    title: 'Contact Us',
    subtitle: 'Reach out via WhatsApp to schedule your healing session',
    quickBook: 'Quick book by service',
    generalButton: 'Book via WhatsApp Now',
    hint: 'Clicking will redirect you to WhatsApp. We will reply as soon as possible.',
    services: ['PELLOWAH', 'UMANA', 'Bach Flower Remedies', 'Quantum Hypnosis', 'Oracle Card Reading', 'Chakra Assessment'],
    whatsappMsg: 'Hello, I would like to book a {service} session. What times are available?',
    whatsappMsgGeneral: 'Hello, I would like to book a healing session. What times are available?',
  },
  footer: {
    brand: 'Sunshine Healing',
    description: 'We are dedicated to providing professional and warm spiritual healing services for everyone seeking spiritual growth. Here, you will find your own peace and strength.',
    address: 'ADDRESS',
    addressLine1: 'Singapore',
    phone: 'PHONE',
    phoneNumber: '+65 9365 1286',
    copyright: '© 2025 Sunshine Healing Studio. All Rights Reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    sitemap: 'Sitemap',
  },
  whatsappBooking: {
    title: 'Book Now',
    subtitle: 'Click the button below to contact us via WhatsApp and schedule your healing session',
    label: 'WhatsApp Contact',
    button: 'Book via WhatsApp',
    hint: 'You will be redirected to WhatsApp. We will reply as soon as possible.',
  },
  pellowahDetail: {
    hero: {
      title: 'PELLOWAH',
      subtitle: 'High-Frequency Energy Healing',
      description: 'High-frequency spiritual energy healing that directly connects to the Higher Self, expands consciousness dimensions, breaks through inner limitations, and opens new life perspectives and spiritual awareness.',
    },
    intro: {
      title: 'What is PELLOWAH',
      content: 'Pellowah is a high-frequency energy healing system designed to elevate consciousness, purify energy, and bring deep body-mind balance. Founded by Australian Kachina Ma\'an, whose name means "the shift of consciousness", Pellowah differs from traditional healing by focusing on directly connecting with high-dimensional energy to facilitate personal spiritual awakening — transforming negative beliefs and emotional patterns from within, and commonly used to relieve psychological stress and promote overall well-being.',
      featuresTitle: 'Core Characteristics of Pellowah Healing',
      features: [
        { title: 'Exceptionally High Frequency', desc: 'Pellowah works directly on the light body and consciousness level, operating at a higher and more refined energy frequency than traditional energy therapies such as Reiki.' },
        { title: 'Non-Touch Practice', desc: 'The healer works without physical contact, using hand movements to guide energy into the client\'s energy field.' },
        { title: 'Change from Within', desc: 'The focus is on facilitating change at the psychological root — subconscious and core beliefs — not merely alleviating symptoms, but dissolving spiritual energy blockages at their source.' },
        { title: 'Enhanced Awareness', desc: 'Strengthens personal awareness of one\'s own thoughts and emotions, enabling more positive choices in everyday life.' },
        { title: 'Wide-Ranging Applications', desc: 'Used to reduce stress, balance emotions, relieve physical and mental exhaustion, and find direction for spiritual growth.' },
      ],
      conclusion: 'Pellowah is ideal for individuals who wish to improve their quality of life, seek inner peace, or pursue self-awakening. Healer Susie from Singapore is the first healer to introduce PELLOWAH healing technology to Singapore.',
    },
    benefits: {
      title: 'Core Benefits',
      benefit1: { title: 'Consciousness Expansion', description: 'Open higher dimensional consciousness channels, enhance spiritual awareness and intuition' },
      benefit2: { title: 'Breaking Limitations', description: 'Release deep belief constraints, breakthrough life bottlenecks and growth obstacles' },
      benefit3: { title: 'Remote Healing', description: 'Not limited by location — sessions can be conducted remotely, allowing you to receive high-frequency energy anytime, anywhere' },
      benefit4: { title: 'Energy Balance', description: 'Harmonize body-mind-spirit energy field, restore inner harmony and peace' },
      benefit5: { title: 'Spiritual Awakening', description: 'Activate soul memory, initiate spiritual growth and life transformation' },
      benefit6: { title: 'Emotional Release', description: 'Gently release suppressed emotions, heal inner trauma and pain' },
    },
    process: {
      title: 'Healing Process',
      step1: { title: 'Energy Preparation', description: 'Through meditation and breathing exercises, bring body and mind into relaxed state to receive high-frequency energy' },
      step2: { title: 'Energy Transmission', description: 'Healer acts as energy channel, transmitting Pellowah high-frequency energy to your energy field' },
      step3: { title: 'Consciousness Expansion', description: 'Under energy influence, consciousness naturally expands, connects with Higher Self wisdom' },
      step4: { title: 'Integration', description: 'After healing, time is given to integrate the experience, allowing energy to continue working in daily life' },
    },
    suitable: {
      title: 'Suitable For',
      content: 'Suitable for all friends seeking spiritual growth and consciousness expansion, especially those feeling lost in life, desiring to breakthrough current situations, and hoping to connect with inner wisdom.',
      item1: 'Those feeling lost in life, lacking direction, and longing to find deeper meaning and purpose',
      item2: 'Those wishing to break through inner limitations and belief constraints to open new life perspectives',
      item3: 'Seekers with a strong desire for spiritual growth and consciousness expansion',
      item4: 'Those experiencing long-term low energy and body-mind imbalance needing deep realignment',
    },
    method: {
      title: 'Healing Method',
      step1: { title: 'Non-Contact Energy Transmission', desc: 'The healer transmits high-frequency Pellowah energy directly through the energy field without physical touch — a relaxed and comfortable experience' },
      step2: { title: 'Deep Meditation Guidance', desc: 'Guided breathing and meditation help you enter a relaxed state, allowing consciousness to naturally expand and receive Higher Self wisdom' },
      step3: { title: 'Energy Integration & Sharing', desc: 'After the session, experience sharing and integration help you ground the energy shifts into your everyday life' },
    },
    cta: { title: 'Begin Your Consciousness Expansion Journey', button: 'Book PELLOWAH Now', back: 'Back to Services' },
    pricing: {
      title: 'Duration & Pricing',
      duration: 'Duration',
      price: 'Price',
      note: 'For more details or special arrangements, feel free to contact us via WhatsApp',
      items: [
        { duration: '60 mins', price: 'SGD $150', label: 'Standard Session' },
        { duration: '90 mins', price: 'SGD $200', label: 'Deep Session' },
      ],
    },
    qhhtSection: {
      overview: {
        tag: 'About QHHT',
        title: 'What is Quantum Healing Hypnosis Technique (QHHT)',
        content: 'Quantum Healing Hypnosis Technique (QHHT) was developed by Dolores Cannon through more than 45 years of practice. It is a unique hypnosis method that guides clients into a deep theta brainwave state to access past life memories or other consciousness experiences. The goal is to connect with the client\'s "Higher Self" to gain insight, clarify life purpose, and facilitate physical and mental healing.',
      },
      elements: {
        title: 'Key Elements of QHHT',
        items: [
          { icon: 'ri-user-star-line', title: 'Founder', desc: 'Developed by Dolores Cannon through over 45 years of dedicated practice and research.' },
          { icon: 'ri-eye-line', title: 'Subconscious / Higher Self', desc: 'QHHT interacts with what Cannon called the "Subconscious" — the infinite, all-knowing part of the self that holds past life information and can facilitate instantaneous healing.' },
          { icon: 'ri-time-line', title: 'Session Structure', desc: 'A typical session lasts 4–5 hours, including an interview about the client\'s life experiences, the hypnosis process itself, and a review of session outcomes.' },
          { icon: 'ri-brain-line', title: 'Theta Brainwave State', desc: 'Visualisation techniques are used to reach the deep theta brainwave state — typically experienced in the moments just before falling asleep or waking up.' },
          { icon: 'ri-history-line', title: 'Past Life Regression (PLR)', desc: 'Rather than seeking a specific past life, QHHT allows the Higher Self to choose the most relevant experience — which may be a past life, another dimension, or a scene from another planet.' },
        ],
      },
      benefits: {
        title: 'Potential Benefits',
        items: [
          { icon: 'ri-heart-pulse-line', title: 'Physical & Mental Healing', desc: 'The Higher Self is guided to scan the body to identify and heal physical conditions.' },
          { icon: 'ri-compass-3-line', title: 'Life Purpose Insights', desc: 'Gain clarity on why you chose your current life circumstances and understand your soul lessons.' },
          { icon: 'ri-shield-flash-line', title: 'Overcoming Fears', desc: 'Address fears, phobias and blocks — including the fear of death.' },
          { icon: 'ri-links-line', title: 'Relationship Clarity', desc: 'Understand karmic relationships and the deeper meaning behind life challenges.' },
        ],
      },
      preparation: {
        title: 'Preparation',
        content: 'It is recommended that you get plenty of rest and prepare yourself mentally for a long and deeply immersive session.',
      },
    },
  },
  umanaDetail: {
    hero: {
      title: 'UMANA',
      subtitle: 'Integrative Healing System',
      description: 'A deep healing system integrating body, mind and spirit. Through energy field recalibration, releases deep trauma and emotional patterns, restoring harmony and wholeness to life source.',
    },
    intro: {
      title: 'What is UMANA',
      content: 'Umana is a technique that uses certain meridians within the body to activate the 8-12 Chakras above the physical body for Growth, Change and empowerment. It is a battery recharge for the Soul. The word UMANA is an Angelic word meaning "Evolutionary Breakthrough". It is a new way to open and access a new meridian system within the body to produce huge consciousness shifts in the person receiving the healing. It is designed to increase consciousness and growth and facilitating a better system of health, wellness and change. All the Meridians and associated chakras have always been there but through the hard access these points to accelerate this process. These Meridians and the Chakras they connect to have been known by many names — activated in a simple yet profound way. In activating these meridians, we will increase our empathetic abilities while keeping detached from all situations. The reason why we use the meridian points is because the chakras that they are activating exist outside the physical body, so it is necessary to use the meridians within the physical body to activate them. Chakras once activated from Umana, it stays activated.',
    },
    chakraDiagram: {
      title: '12 Chakra Distribution Map',
      description: 'UMANA healing activates Chakras 8–12 existing beyond the physical body. Together with the traditional Chakras 1–7, they form a complete 12-chakra energy system, bringing unprecedented consciousness shifts and deep healing.',
    },
    superChakras: {
      title: 'Extra-Physical Chakra Introduction',
      quote: 'Chakras are energy conduits in the subtle body that can absorb and process energy of a higher essential vibrational frequency, allowing that energy to be properly absorbed and used to transform the physical body',
      quoteAuthor: '— Richard Gerber',
      intro: 'With all chakras balanced and open, the following extra-physical chakras can be activated:',
      chakras: [
        { number: 'Chakra 8', desc: 'Transcends self and Earth dimensions — spiritual wisdom and heightened perception' },
        { number: 'Chakra 9', desc: 'The energy of connection to the cosmos. The capacity for enlightenment lies dormant in the 9th Chakra, waiting to be awakened and used in both the inner and outer world' },
        { number: 'Chakra 10', desc: 'When the 10th Chakra opens, the individual begins to manifest all the skills and wisdom accumulated over past lifetimes. Under the blessing of this chakra, opportunities arise naturally — without setting intentions, deliberate pursuit or effortful striving. The universe arranges everything' },
        { number: 'Chakra 11', desc: 'This chakra carries an energetic connection that enables the individual to manifest higher-order spiritual abilities' },
        { number: 'Chakra 12', desc: 'Our divine connection to Source — it brings a sense of wholeness and oneness. This chakra allows all dimensions and realities to merge and coexist, opening them to you so you can simultaneously exist and move between all Dimensions and Realms' },
      ],
      susieNote: 'Spiritual healer Susie from Singapore was the first healer to introduce Umana healing technology to Singapore',
      summary: 'UMANA healing activates Chakras 8–12 existing beyond the physical body. Together with the traditional Chakras 1–7, they form a complete 12-chakra energy system, bringing unprecedented consciousness shifts and deep healing.',
    },
    benefits: {
      title: 'Healing Benefits',
      benefit1: { title: 'Activate Chakras 8–12 Above the Physical Body', description: 'Release trauma and pain stored in cellular memory, heal from the root' },
      benefit2: { title: 'Massive Consciousness Shift & Mind-Body Balance', description: 'Identify and transform recurring negative emotional patterns and behavioral habits' },
      benefit3: { title: 'Can Heal the Earth, Bless Businesses or Locations\' Energy Fields', description: 'Recalibrate the energy field, restore harmony and balance across all body-mind-spirit levels' },
      benefit4: { title: 'See Beyond Your Perspective to Perceive the Truth', description: 'Connect body, emotions, mind and spirit, achieve holistic balance' },
      benefit5: { title: 'Life Force Restoration', description: 'Activate life source energy, enhance overall vitality and life quality' },
      benefit6: { title: 'Inner Wholeness', description: 'Rebuild inner integrity, rediscover authentic self and life power' },
    },
    process: {
      title: 'Healing Process',
      step1: { title: 'Energy Assessment', description: 'Through energy scanning, identify imbalances and blockages at all body-mind-spirit levels' },
      step2: { title: 'Deep Release', description: 'Using UMANA techniques, release deep trauma, emotional patterns and limiting beliefs' },
      step3: { title: 'Energy Calibration', description: 'Recalibrate energy field, restore harmony and balance at all body-mind-spirit levels' },
      step4: { title: 'Integration', description: 'Integrate healing experience, establish new healthy patterns, consolidate healing results' },
    },
    suitable: {
      title: 'Suitable For',
      content: 'Suitable for friends who have experienced deep trauma, long-term emotional distress, recurring negative patterns, as well as those hoping for comprehensive body-mind-spirit integration and deep healing.',
      item1: 'Age 16 and above',
      item2: 'Those longing for higher consciousness awakening',
      item3: 'Those feeling body-mind-spirit imbalance and low vitality, longing to fully restore energy and aliveness',
      item4: 'Those wishing to transform limiting beliefs at the root, rebuild inner wholeness and transcend themselves',
    },
    method: {
      title: 'Healing Method',
      step1: { title: 'In-Person, Lying Down or Seated', desc: 'Requires light physical contact' },
      step2: { title: 'Remote Session — No Physical Contact', desc: 'Client needs to be in a quiet, undisturbed space' },
      step3: { title: 'Light or Deep Healing — Your Choice', desc: 'Light healing: 30 mins, activates Chakras 8–10; Deep healing: 60 mins, activates all Chakras 8–12 outside the physical body' },
    },
    cta: { title: 'Begin Your Integrative Healing Journey', button: 'Book UMANA Now', back: 'Back to Services' },
    pricing: {
      title: 'Duration & Pricing',
      duration: 'Duration',
      price: 'Price',
      note: 'For more details or special arrangements, feel free to contact us via WhatsApp',
      items: [
        { duration: '30 mins', price: 'SGD $80', label: 'Light Healing' },
        { duration: '60 mins', price: 'SGD $150', label: 'Deep Healing' },
      ],
    },
  },
  bachDetail: {
    hero: {
      title: 'Bach Flower Remedies',
      subtitle: 'Natural Flower Essence Healing',
      description: 'Using the vibrational energy of 38 natural flower essences, gently and precisely harmonizing negative emotions and mental states, healing emotional imbalance at the root and rebuilding inner calm and confidence.',
    },
    intro: {
      title: 'What are Bach Flower Remedies',
      content: 'Bach Flower Remedies were created by British physician Dr. Edward Bach in the 1930s, a gentle and effective natural therapy. It uses the vibrational energy of 38 carefully selected wild flowers to precisely harmonize different negative emotional states.',
    },
    benefits: {
      title: 'Core Benefits',
      benefit1: { title: 'Emotional Harmonization', description: 'Precisely harmonize 38 negative emotional states including anxiety, fear, anger' },
      benefit2: { title: 'Gentle Healing', description: 'Pure natural energy therapy, no side effects, safe and gentle' },
      benefit3: { title: 'Root Healing', description: 'Address emotional roots rather than merely suppressing symptoms' },
      benefit4: { title: 'Inner Peace', description: 'Rebuild inner peace and tranquility, enhance emotional stability' },
      benefit5: { title: 'Confidence Rebuilding', description: 'Heal self-doubt and fear, rebuild inner confidence and strength' },
      benefit6: { title: 'Personalized Formula', description: 'Customize exclusive flower essence formula based on individual emotional state' },
    },
    process: {
      title: 'Healing Process',
      step1: { title: 'Emotional Assessment', description: 'Through in-depth communication, identify current emotional state and inner needs' },
      step2: { title: 'Formula Customization', description: 'Precisely select from 38 flower essences, blend personalized formula for you' },
      step3: { title: 'Usage Guidance', description: 'Detailed explanation of flower essence usage method, frequency and precautions' },
      step4: { title: 'Continuous Follow-up', description: 'Regular follow-up on emotional changes, adjust flower essence formula as needed' },
    },
    suitable: {
      title: 'Suitable For',
      content: 'Suitable for all friends experiencing emotional distress, including anxiety, depression, fear, anger, self-doubt. Especially suitable for those hoping to heal emotions through natural gentle methods.',
      item1: 'Those suffering from long-term negative emotions such as anxiety, fear, depression or anger',
      item2: 'Those facing major life transitions (job loss, breakup, bereavement) who need emotional support',
      item3: 'Children, pregnant women and those sensitive to chemical medications who prefer a purely natural approach',
      item4: 'Those experiencing self-doubt and low confidence who wish to rebuild inner strength and calm',
    },
    method: {
      title: 'Healing Method',
      step1: { title: 'In-Depth Emotional Assessment', desc: 'Through gentle and thorough conversation, we fully understand your current emotional state, life background and inner needs, building a foundation of trust' },
      step2: { title: 'Personalized Flower Essence Formula', desc: 'Carefully selecting from 38 natural flower essences to blend a bespoke formula tailored to your unique emotional patterns and needs' },
      step3: { title: 'Ongoing Follow-Up & Adjustment', desc: 'Regular check-ins to track emotional changes and healing progress, flexibly adjusting the formula as needed to ensure the best results' },
    },
    cta: { title: 'Begin Your Flower Essence Healing Journey', button: 'Book Bach Flower Remedies Now', back: 'Back to Services' },
    pricing: {
      title: 'Duration & Pricing',
      duration: 'Duration',
      price: 'Price',
      note: 'For more details or special arrangements, feel free to contact us via WhatsApp',
      items: [
        { duration: '60 mins', price: 'SGD $120', label: 'Assessment + Formula' },
        { duration: '30 mins', price: 'SGD $60', label: 'Follow-up Adjustment' },
      ],
    },
  },
  quantumDetail: {
    hero: {
      title: 'Quantum Hypnosis (QHHT)',
      subtitle: 'Deep Consciousness Exploration',
      description: 'Through deep hypnotic guidance, connect with subconscious and Higher Self wisdom, explore past lives, soul missions and life lessons, gaining profound inner insights and healing transformation.',
    },
    intro: {
      title: 'What is Quantum Hypnosis (QHHT)',
      content: 'Quantum Hypnosis is a deep hypnosis technique that helps you enter deep subconscious states and connect with Higher Self wisdom and soul memory. In this state, you can explore past life experiences, understand soul missions and life lessons, and gain profound insights into current life challenges.',
    },
    benefits: {
      title: 'Core Benefits',
      benefit1: { title: 'Past Life Exploration', description: 'Explore past life memories, understand deep roots of current life lessons' },
      benefit2: { title: 'Soul Mission', description: 'Connect with Higher Self wisdom, understand soul mission and life purpose' },
      benefit3: { title: 'Deep Healing', description: 'Release trauma and fears from past and present lives, achieve deep healing' },
      benefit4: { title: 'Inner Insights', description: 'Gain profound insights and wisdom guidance about life challenges' },
      benefit5: { title: 'Relationship Healing', description: 'Understand soul contracts, heal lessons in important relationships' },
      benefit6: { title: 'Life Transformation', description: 'Achieve transformation at soul level, find life meaning and direction' },
    },
    process: {
      title: 'Healing Process',
      step1: { title: 'Preparation', description: 'Understand your needs and questions, explain hypnosis process and precautions' },
      step2: { title: 'Deep Relaxation', description: 'Through guidance, bring body and mind into deeply relaxed hypnotic state' },
      step3: { title: 'Subconscious Exploration', description: 'In hypnotic state, explore past life memories, soul mission and life lessons' },
      step4: { title: 'Healing Integration', description: 'Release deep trauma, gain insights, integrate hypnosis experience' },
      step5: { title: 'Awakening & Sharing', description: 'Gentle awakening, share experience, answer questions, provide follow-up guidance' },
    },
    suitable: {
      title: 'Suitable For',
      content: 'Suitable for friends interested in past lives and soul missions, as well as those hoping to understand root causes of life challenges and seeking profound healing and transformation.',
      item1: 'Those with a strong desire to explore past lives, soul missions and the deeper meaning of life',
      item2: 'Those facing recurring life challenges who wish to find root-cause answers and breakthroughs',
      item3: 'Those with unexplained fears, physical symptoms or emotional patterns suspected to be linked to past lives',
      item4: 'Those longing to build a deep connection with their Higher Self and receive soul-level guidance and healing',
      item5: 'In-person Mandarin sessions only — no remote sessions, Mandarin-speaking clients only',
    },
    method: {
      title: 'Healing Method',
      step1: { title: 'Deep Hypnotic Induction', desc: 'Using professional verbal guidance and relaxation techniques to safely guide you into a deep subconscious state, with the healer present throughout the entire session' },
      step2: { title: 'Subconscious Dialogue & Exploration', desc: 'In the hypnotic state, engaging in deep dialogue with the subconscious and Higher Self to explore past life memories, soul missions and the roots of current life challenges' },
      step3: { title: 'Healing Integration & Awakening', desc: 'Completing deep healing under Higher Self guidance, followed by gentle awakening, experience integration and detailed follow-up recommendations' },
    },
    cta: { title: 'Begin Your Quantum Hypnosis Journey', button: 'Book Quantum Hypnosis Now', back: 'Back to Services' },
    pricing: {
      title: 'Duration & Pricing',
      duration: 'Duration',
      price: 'Price',
      note: 'Session length varies by individual. We recommend allowing ample time. Contact us to learn more.',
      items: [
        { duration: '3 – 4 hours', price: 'SGD $450', label: 'Full Hypnosis Session' },
      ],
    },
    qhhtSection: {
      overview: {
        tag: 'About QHHT',
        title: 'What is Quantum Healing Hypnosis Technique (QHHT)',
        content: 'Quantum Healing Hypnosis Technique (QHHT) was developed by Dolores Cannon through more than 45 years of practice. It is a unique hypnosis method that guides clients into a deep theta brainwave state to access past life memories or other consciousness experiences. The goal is to connect with the client\'s "Higher Self" to gain insight, clarify life purpose, and facilitate physical and mental healing.',
      },
      elements: {
        title: 'Key Elements of QHHT',
        items: [
          { icon: 'ri-user-star-line', title: 'Founder', desc: 'Developed by Dolores Cannon through over 45 years of dedicated practice and research.' },
          { icon: 'ri-eye-line', title: 'Subconscious / Higher Self', desc: 'QHHT interacts with what Cannon called the "Subconscious" — the infinite, all-knowing part of the self that holds past life information and can facilitate instantaneous healing.' },
          { icon: 'ri-time-line', title: 'Session Structure', desc: 'A typical session lasts 4–5 hours, including an interview about the client\'s life experiences, the hypnosis process itself, and a review of session outcomes.' },
          { icon: 'ri-brain-line', title: 'Theta Brainwave State', desc: 'Visualisation techniques are used to reach the deep theta brainwave state — typically experienced in the moments just before falling asleep or waking up.' },
          { icon: 'ri-history-line', title: 'Past Life Regression (PLR)', desc: 'Rather than seeking a specific past life, QHHT allows the Higher Self to choose the most relevant experience — which may be a past life, another dimension, or a scene from another planet.' },
        ],
      },
      benefits: {
        title: 'Potential Benefits',
        items: [
          { icon: 'ri-heart-pulse-line', title: 'Physical & Mental Healing', desc: 'The Higher Self is guided to scan the body to identify and heal physical conditions.' },
          { icon: 'ri-compass-3-line', title: 'Life Purpose Insights', desc: 'Gain clarity on why you chose your current life circumstances and understand your soul lessons.' },
          { icon: 'ri-shield-flash-line', title: 'Overcoming Fears', desc: 'Address fears, phobias and blocks — including the fear of death.' },
          { icon: 'ri-links-line', title: 'Relationship Clarity', desc: 'Understand karmic relationships and the deeper meaning behind life challenges.' },
        ],
      },
      preparation: {
        title: 'Preparation',
        content: 'It is recommended that you get plenty of rest and prepare yourself mentally for a long and deeply immersive session.',
      },
    },
  },
  oracleDetail: {
    hero: {
      title: 'Oracle Card Reading',
      subtitle: 'Divine Wisdom & Intuitive Guidance',
      description: 'Using the divine wisdom and intuitive guidance of oracle cards to bring clarity and insight to your current life questions, connecting with inner wisdom to find direction and strength for moving forward.',
    },
    intro: {
      title: 'What are Oracle Cards',
      content: 'Oracle cards are an ancient spiritual tool that transmits messages from the Higher Self, universe and inner wisdom through sacred symbols, images and words. Each card contains profound spiritual wisdom and intuitive guidance, bringing clarity and direction to your current life questions.',
    },
    benefits: {
      title: 'Core Benefits',
      benefit1: { title: 'Clear Insights', description: 'Bring clear insights and understanding to current life questions' },
      benefit2: { title: 'Intuitive Connection', description: 'Strengthen intuition, connect with inner wisdom and Higher Self guidance' },
      benefit3: { title: 'Direction Guidance', description: 'Gain direction when confused, find path forward' },
      benefit4: { title: 'Inner Strength', description: 'Awaken inner strength and courage to face life challenges' },
      benefit5: { title: 'Spiritual Growth', description: 'Through card messages, gain inspiration and guidance for spiritual growth' },
      benefit6: { title: 'Present Awareness', description: 'Enhance awareness of the present, see truth of life' },
    },
    process: {
      title: 'Reading Process',
      step1: { title: 'Intention Setting', description: 'Clarify the life question you want to explore or guidance you seek' },
      step2: { title: 'Card Drawing & Reading', description: 'In relaxed state, draw cards and receive divine messages' },
      step3: { title: 'Deep Interpretation', description: 'Combining intuition and spiritual wisdom, deeply interpret card messages' },
      step4: { title: 'Integration & Application', description: 'Integrate card guidance into life, find direction for practice' },
    },
    suitable: {
      title: 'Suitable For',
      content: 'Suitable for all friends at life crossroads, facing important decisions, feeling confused, as well as those hoping to connect with inner wisdom, enhance intuition, and seek spiritual guidance.',
      item1: 'Those facing important life decisions (career, relationships, life direction) who need clear guidance',
      item2: 'Those feeling lost or confused, seeking messages and support from inner wisdom and the universe',
      item3: 'Seekers wishing to strengthen intuition, deepen their Higher Self connection and begin spiritual growth',
      item4: 'Those needing emotional support and soul companionship, seeking warm and meaningful spiritual guidance',
    },
    method: {
      title: 'Healing Method',
      step1: { title: 'Intention Setting & Energy Attunement', desc: 'Before the reading begins, you are guided to clarify your inner question and attune your energy through meditation and breathing, preparing to receive divine messages' },
      step2: { title: 'Intuitive Card Drawing & Spread Reading', desc: 'A suitable spread is chosen for your question; cards are drawn intuitively in a relaxed state and deeply interpreted through imagery, symbols and spiritual wisdom' },
      step3: { title: 'Insight Integration & Action Guidance', desc: 'Card messages are connected to your real-life situation, providing concrete and actionable insights and suggestions to help you move forward with clarity' },
    },
    cta: { title: 'Begin Your Oracle Card Journey', button: 'Book Oracle Card Reading Now', back: 'Back to Services' },
    pricing: {
      title: 'Duration & Pricing',
      duration: 'Duration',
      price: 'Price',
      note: 'For more details or special arrangements, feel free to contact us via WhatsApp',
      items: [
        { duration: '15 mins', price: 'SGD $40', label: 'Single Topic Reading' },
        { duration: '30 mins', price: 'SGD $60', label: 'In-Depth Full Reading' },
      ],
    },
  },
  chakraDetail: {
    hero: {
      title: 'Chakra Assessment',
      subtitle: 'Energy Centre Evaluation & Balancing',
      description: 'Through systematic evaluation of the seven major chakra energy centres, precisely locate blockages and imbalances, deeply understand the inner connection between body, emotions and spirit, and embark on a journey of comprehensive self-discovery and healing.',
    },
    intro: {
      title: 'What is a Chakra Assessment',
      content: 'Chakras are the seven major energy centres of the human body, extending from the base of the spine to the crown of the head, each corresponding to specific body areas, emotional states and spiritual dimensions. A Chakra Assessment uses professional energy evaluation methods to systematically examine the openness and energy flow of each chakra, identifying blocked or overactive energy centres. This helps you gain deep insight into your physical, emotional and spiritual condition, and provides targeted healing recommendations and personalised plans.',
    },
    benefits: {
      title: 'Core Benefits',
      benefit1: { title: 'Precise Evaluation', description: 'Systematically assess all seven chakra energy states to identify imbalances and blockages' },
      benefit2: { title: 'Deep Self-Awareness', description: 'Understand the emotions, behavioural patterns and life lessons associated with each chakra' },
      benefit3: { title: 'Targeted Healing', description: 'Develop a personalised, targeted healing plan based on your assessment results' },
      benefit4: { title: 'Energy Harmonisation', description: 'Guided healing to gradually restore harmonious energy flow between all chakras' },
    },
    suitable: {
      title: 'Suitable For',
      item1: 'Those confused about their energy state, wishing to deeply understand the inner connections of body, mind and spirit',
      item2: 'Those experiencing unexplained physical discomfort, emotional fluctuations or life challenges seeking root-cause exploration',
      item3: 'Those beginning their spiritual journey, looking for a systematic assessment to find the right entry point for healing',
      item4: 'Those with healing experience who wish to better understand their energy state to deepen their practice',
      item5: 'Curious explorers interested in energy medicine and the chakra system who want a comprehensive systematic evaluation',
    },
    method: {
      title: 'Assessment Method',
      step1: { title: 'In-Depth Questionnaire', desc: 'A professional questionnaire covering physical, emotional, mental and spiritual dimensions to systematically gather information on all seven chakra states' },
      step2: { title: 'Energy Scanning & Interpretation', desc: 'Combining intuitive perception and energy assessment techniques to deeply interpret each chakra, identifying imbalance patterns and root causes' },
      step3: { title: 'Personalised Report & Recommendations', desc: 'Integrating assessment results into a detailed chakra energy report with specific actionable healing recommendations and a follow-up plan' },
    },
    chakras: {
      title: 'The Seven Chakras',
      items: [
        { name: 'Root Chakra', color: 'Security', description: 'Foundation and safety, survival instincts and material stability' },
        { name: 'Sacral Chakra', color: 'Creativity', description: 'Emotional flow, creativity and interpersonal relationships' },
        { name: 'Solar Plexus', color: 'Willpower', description: 'Personal power, self-confidence and drive to act' },
        { name: 'Heart Chakra', color: 'Love', description: 'Capacity to love, empathy and inner harmony' },
        { name: 'Throat Chakra', color: 'Expression', description: 'Authentic expression, communication and creative voice' },
        { name: 'Third Eye', color: 'Intuition', description: 'Intuition, insight and inner wisdom' },
        { name: 'Crown Chakra', color: 'Spirituality', description: 'Spiritual connection, cosmic consciousness and higher wisdom' },
      ],
    },
    cta: { title: 'Begin Your Chakra Exploration Journey', button: 'Book Chakra Assessment Now', back: 'Back to Services' },
    pricing: {
      title: 'Duration & Pricing',
      note: 'For more details or special arrangements, feel free to contact us via WhatsApp',
      items: [
        { duration: '15 mins', price: 'SGD $30', label: 'Quick Assessment' },
        { duration: '30 mins', price: 'SGD $60', label: 'In-Depth Reading' },
        { duration: '60 mins', price: 'SGD $100', label: 'Test + Initial Healing Guidance' },
      ],
    },
  },
  healer: {
    eyebrow: 'About the Healer',
    title: 'Your Spiritual Guide & Companion',
    name: 'Susie',
    role: 'Certified Spiritual Healer · Singapore',
    bio: 'Susie has over 5 years of experience in spiritual healing, specialising in PELLOWAH, UMANA, Bach Flower Remedies, Quantum Hypnosis and Oracle Card Reading. Known for her warmth, professionalism and sharp intuition, she has guided hundreds of clients through life\'s challenges, helping them rediscover inner peace and strength. She believes every person carries the wisdom to heal themselves — her mission is to be the gentle sunshine that guides you back to your authentic self.',
    yearsNum: '5+',
    yearsLabel: 'Years of Experience',
    credentialsTitle: 'Certifications & Credentials',
    credentials: [
      'International Certified PELLOWAH Energy Healing Instructor',
      'Certified UMANA Integrative Healing Practitioner',
      'Bach Foundation Registered Practitioner (BFRP)',
      'Quantum Healing Hypnosis Technique (QHHT) Certified Practitioner',
      'Bilingual Services (Mandarin / English)',
    ],
    qualities: [
      { icon: 'ri-heart-line', title: 'Warm Presence', desc: 'A compassionate and gentle approach where you feel fully seen and accepted in a safe space' },
      { icon: 'ri-shield-check-line', title: 'Trusted Professional', desc: 'Backed by multiple international certifications with strict adherence to ethics and confidentiality' },
      { icon: 'ri-sparkling-line', title: 'Sharp Intuition', desc: 'Deep spiritual practice and rich experience to precisely sense and respond to your inner needs' },
    ],
  },
};
